import { adjustPostTags } from "./functions";
import { debounce, distinctUntilChanged, filter, fromEvent, interval, map, Observable, switchMap } from 'rxjs';
import { ajax } from 'rxjs/ajax';

/*--------------------------------------------------------------------------
 * Function copy from patent theme, for handling ajax register submission.
 * -------------------------------------------------------------------------*/
export function handleRegisterSubmit() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    var houzez_reCaptcha = parseInt((window as any).houzez_reCaptcha);
    
    jQuery('#houzez-register-btn').on('click', function(e){
        e.preventDefault();
        var currnt = jQuery(this);
        houzez_register( currnt );
    });

    var reCaptchaIDs:any = [];
    var siteKey = '<?php echo $reCAPTCHA_site_key; ?>';
    var reCaptchaType = '<?php echo $recaptha_type; ?>';
    var houzezReCaptchaLoad = function() {
        jQuery( '.houzez_google_reCaptcha' ).each( function( index, el ) {
            var tempID;
            if ( reCaptchaType === 'v3' ) {
                tempID = ( window as any).grecaptcha.ready(function () {
                    ( window as any).grecaptcha.execute(siteKey, {action: 'homepage'}).then(function (token:any) {
                        el.insertAdjacentHTML('beforeend', '<input type="hidden" class="g-recaptcha-response" name="g-recaptcha-response" value="' + token + '">');
                    });
                });
            } else {
                tempID = ( window as any).grecaptcha.render( el, {
                    'sitekey' : siteKey
                } );
            }
            reCaptchaIDs.push( tempID );
        } );
    };

    //reCAPTCHA reset
    var houzezReCaptchaReset = function() {
        if ( reCaptchaType === 'v2' ) {
            if( typeof reCaptchaIDs != 'undefined' ) {
                var arrayLength = reCaptchaIDs.length;
                for( var i = 0; i < arrayLength; i++ ) {
                   ( window as any).grecaptcha.reset( reCaptchaIDs[i] );
                }
            }
        } else {
            houzezReCaptchaLoad();
        }
    };

    var houzez_register = function ( currnt:JQuery<HTMLElement> ) {
        let $form = currnt.parents('form');
        const form = $form[0];
        let $messages = jQuery('#hz-register-messages');
        let g_recaptha_version = (window as any).g_recaptha_version;
        let formData = new FormData(form);

        let beforeSend = function( ) {
            currnt.find('.houzez-loader-js').addClass('loader-show');
        };

        let complete = function(){
            currnt.find('.houzez-loader-js').removeClass('loader-show');
        };

        let success = function( response : any ) {
            if( response.success ) {
                $messages.empty().append('<div class="alert alert-success" role="alert"><i class="houzez-icon icon-check-circle-1 mr-1"></i>'+ response.msg +'</div>');
            } else {
                $messages.empty().append('<div class="alert alert-danger" role="alert"><i class="houzez-icon icon-check-circle-1 mr-1"></i>'+ response.msg +'</div>');
            }

            currnt.find('.houzez-loader-js').removeClass('loader-show');
            if(houzez_reCaptcha == 1) {
                $form.find('.g-recaptcha-response').remove();
                if( g_recaptha_version == 'v3' ) {
                    houzezReCaptchaLoad();
                } else {
                    houzezReCaptchaReset();
                }
            }
        };

        let error = function(xhr: any, status: any, error: any) {
            var err = eval("(" + xhr.responseText + ")");
            console.log(err.Message);
        }

        // let data = $form.serialize();
        let data = new FormData(form); //Use formData method to handle file uploaded by form.
        
        jQuery.ajax({
            type: 'post',
            url: ajaxurl,
            dataType: 'json',
            data,
            contentType: false,
            processData: false,
            //data:  formData,
            beforeSend,
            complete,
            success,
            error,
        });
    }
}

/*--------------------------------------------------------------------------
 * Function to check if a phone number already exist.
 * -------------------------------------------------------------------------*/
export function handleRegisterPhoneChecking() {
    let ajaxurl = ((window as any).houzez_vars.admin_url as string) + 'admin-ajax.php';
    const register_form = document.querySelector('#fy-register-form');
    if (register_form) {
        // const phone_field = register_form.querySelector('input[name="phone_number"]') as HTMLInputElement;
        // phone_field.addEventListener('keyup', (e) => {
        //     console.log(e.value);
        // })
        let phoneNumberField = register_form.querySelector('input[name="phone_number"]') as HTMLInputElement;
        fromEvent(phoneNumberField, 'input')
            .pipe(map(ev => (ev.target as HTMLInputElement).value))
            .pipe(filter(searchTerm => 
            {
                return searchTerm.length >= 8;
            }))
            .pipe(debounce(searchTerm => interval(300)))
            .pipe(distinctUntilChanged())
            //.subscribe(searchTerm => console.log(searchTerm));
            .pipe(switchMap((searchTerm : string) => 
                ajax(ajaxurl + `?action=registerPhoneChecking&phoneNumber=${searchTerm}`)
                    .pipe(
                        map(resp => {
                            //console.log(resp);
                            return {
                                "status" : resp["status"] == 200,
                                "details" : resp["status"] == 200 ? resp["response"] : [],
                                "result_hash": Date.now()
                            };
                        }
                    ))
            ))
            .pipe(filter(resp => resp.status !== false))
            .subscribe(resp => {
                let found = (resp.details as any).found;
                let message = (resp.details as any).message;

                let alertMessage = document.querySelector("#hz-register-messages") as HTMLElement;
                alertMessage.innerHTML = message;
                let verifyButton = document.querySelector('#phone-verify-request-button') as HTMLElement;
                if (found) {
                    verifyButton.classList.add('disable-button');
                } else {
                    verifyButton.classList.remove('disable-button');
                }
            });
        // jQuery(phoneNumberField).on('keyup', function(e){
        //     // var $this = jQuery(this);
        //     console.log(phoneNumberField.value);
        //     // if ($this.value)
        //     // jQuery.ajax({
        //     //     url: ajaxurl,
        //     //     data: {
        //     //         'action': 'registerPhoneChecking'
        //     //     },
        //     //     complete: function (response) {
        //     //         jQuery('.side-menu-item-listings a').text(response.responseText);
        //     //     }
        //     // });
        // });
    }
}

